"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/helpers/ucfirst.js
// module id = 2177
// module chunks = 1